import { MenuItem } from "../../common/models/contentful/trayMenuItems";
import { UserContext } from "../../common/usercontext/user.context";
import { CLAIM_STATUS_TYPE, CLAIM_TYPE, PAYMENTS_NAV_KEY } from "../../constants/constants";

export const showMenuItem = (menuItem: MenuItem, contextData: UserContext) => {
    // Only filter the Payments menu item based on conditions
    if (menuItem.key === PAYMENTS_NAV_KEY) {
        // Include Payments menu item only if at least one IP claim is approved or there are payments on an IP claim
        const hasIpApprovedClaim = contextData.claims.some(claim =>
            claim.claimTypeName === CLAIM_TYPE.IP &&
            claim.status.description === CLAIM_STATUS_TYPE.APPROVED
        );
        const hasIpClaim = contextData.claims.some(claim =>
            claim.claimTypeName === CLAIM_TYPE.IP)
        const hasHistoricalIpPayments = contextData.historicalPayments?.some(payment =>
            payment.claimType === CLAIM_TYPE.IP
        );
        const hasScheduledIpPayments = contextData.scheduledPayments?.some(payment =>
            payment.claimType === CLAIM_TYPE.IP
        );

        // If the Payments menu item is not visible, skip it
        if (!hasIpApprovedClaim && !((hasHistoricalIpPayments || hasScheduledIpPayments) && hasIpClaim)) return false;
        
    }
    return true; // For other menu items, always show them
}